"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ApiShared_1 = require("../../ApiShared");
class CustomViewImpl {
    constructor(customViewModel, _registryId) {
        this._registryId = _registryId;
        this._luid = customViewModel.luid;
        this._name = customViewModel.name;
        this._shared = customViewModel.shared;
        this._isDefault = customViewModel.isDefault;
        this._ownerName = customViewModel.owner.userFriendlyName;
        this._url = customViewModel.url;
    }
    get luid() {
        return this._luid;
    }
    get name() {
        return this._name;
    }
    set name(name) {
        this._name = name;
    }
    get shared() {
        return this._shared;
    }
    set shared(shared) {
        this._shared = shared;
    }
    get isDefault() {
        return this._isDefault;
    }
    set isDefault(isDefault) {
        this._isDefault = isDefault;
    }
    get ownerName() {
        return this._ownerName;
    }
    get url() {
        return this._url;
    }
    saveAsync() {
        const service = ApiShared_1.ApiServiceRegistry.get(this._registryId).getService("viz-service" /* Viz */);
        return service.saveAsync(this);
    }
}
exports.CustomViewImpl = CustomViewImpl;
//# sourceMappingURL=CustomViewImpl.js.map